import React, { useState } from 'react';

import BlogPostCommentFormField from '../BlogPostCommentFormField/BlogPostCommentFormField';

import './BlogPostCommentForm.css';

const BlogPostCommentForm = ({
  onSubmit,
  isSubmitting,
  successMsg,
  setSuccessMsg,
}) => {
  const initialFormState = {
    name: '',
    email: '',
    website: '',
    content: '',
  };

  const [formData, setFormData] = useState(initialFormState);

  const { name, email, website, content } = formData;

  /* ---------- Handlers ---------- */

  const handleInputChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

    // Clear success message when user edits again
    if (successMsg) setSuccessMsg('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await onSubmit(formData);

      // Only reset if successful
      setFormData(initialFormState);
      setSuccessMsg('Comment submitted successfully!');
    } catch (err) {
      console.error('Submit failed:', err);
      // Do NOT reset form on error
    }
  };

  /* ---------- Render ---------- */

  return (
    <form className='blog-post-comment-form' onSubmit={handleSubmit}>
      <BlogPostCommentFormField
        type='text'
        name='name'
        label='Name'
        value={name}
        onChange={handleInputChange}
        required
      />

      <BlogPostCommentFormField
        type='email'
        name='email'
        label='E-mail'
        value={email}
        onChange={handleInputChange}
        autoComplete='on'
        required
      />

      <BlogPostCommentFormField
        type='url'
        pattern='https?://.+'
        name='website'
        label='Website'
        value={website}
        onChange={handleInputChange}
        autoComplete='on'
      />

      <BlogPostCommentFormField
        type='textarea'
        name='content'
        label='Comment'
        value={content}
        onChange={handleInputChange}
        required
      />

      <div className='blog-post-comment-form-submit-btn-container'>
        <button type='submit' disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Send'}
        </button>
      </div>
    </form>
  );
};

export default BlogPostCommentForm;
